import _remove from "lodash/remove";
import _debounce from "lodash/debounce";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import ResizeObserver from 'resize-observer-polyfill';
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { MatchHeightContext } from "../../../context/matchheight.context";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MatchHeight = function MatchHeight(_ref) {
  var children = _ref.children,
    breakpoint = _ref.breakpoint,
    _ref$bypass = _ref.bypass,
    bypass = _ref$bypass === void 0 ? 'none' : _ref$bypass;
  var groups = {};
  var onResize = function onResize(group) {
    return function () {
      var height = 0;
      groups[group].children.forEach(function (child) {
        height = Math.max(height, child.offsetHeight);
      });
      groups[group].wrappers.forEach(function (wrapper) {
        wrapper.style.height = "".concat(height, "px");
      });
    };
  };
  var register = function register(group, wrapperRef, childRef) {
    if (!groups[group]) {
      var resize = _debounce(onResize(group), 100, {
        maxWait: 1000
      });
      groups[group] = {
        observer: new ResizeObserver(resize),
        wrappers: [],
        children: [],
        onResize: onResize
      };
    }
    if (childRef) {
      groups[group].observer.observe(childRef);
      groups[group].children.push(childRef);
    }
    if (wrapperRef) {
      groups[group].wrappers.push(wrapperRef);
    }
    groups[group].onResize(group);
  };
  var unregister = function unregister(group, wrapperRef, childRef) {
    if (groups[group]) {
      childRef && groups[group].observer.unobserve(childRef);
      _remove(groups[group].wrappers, function (n) {
        return n === wrapperRef;
      });
      _remove(groups[group].children, function (n) {
        return n === childRef;
      });
      groups[group].onResize(group);
    }
  };
  var context = {
    register: register,
    unregister: unregister
  };
  var bypassContext = {
    bypassType: bypass,
    register: function register() {},
    unregister: function unregister() {}
  };
  if (breakpoint && bypass && bypass === 'responsive') {
    // when above the specified breakpoint apply matchheight
    // when below the specified breakpoint bypass matchheight
    return /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: breakpoint,
      children: [/*#__PURE__*/_jsx(MatchHeightContext.Provider, {
        value: bypassContext,
        children: children && typeof children === 'function' ? children('below') : children
      }), /*#__PURE__*/_jsx(MatchHeightContext.Provider, {
        value: context,
        children: children && typeof children === 'function' ? children('above') : children
      })]
    });
  } else {
    // if stacked, set the context to bypass
    return /*#__PURE__*/_jsx(MatchHeightContext.Provider, {
      value: bypass === 'stacked' ? bypassContext : context,
      children: children
    });
  }
};